<template>
  <div class="w-full my-8">
    <div class="gridClass">
      <div class="w-full flex flex-col " v-for="item in items" :key="item.id">
        <template v-if="item.title && item.desc">
          <div class="flex flex-col text-center">
            <h2 class="mb-3">
              {{ item.title }}
            </h2>
            <p class="text-center text-body1-bold opacity-50">
              {{ item.desc }}
            </p>
          </div>
        </template>
        <BaseCard v-for="i of item.listThird" :key="i.id" :item="i" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  items: Array,
})
</script>
